require('./brokerTransferOfDerivativesWizardView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerCreateTransferOfDerivativesWizard = require('components/broker/brokerCreateTransferOfDerivativesWizard/brokerCreateTransferOfDerivativesWizard');
const BrokerCreateTransferOfDerivativesWizardSuccess = require('components/broker/brokerCreateTransferOfDerivativesWizard/brokerCreateTransferOfDerivativesStepSuccess/brokerCreateTransferOfDerivativesWizardSuccess');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerCreateTransferOfDerivativesActions = require('actions/brokerCreateTransferOfDerivatives');

// @constants
const {
    MYPROFILE_BROKER_URL,
    MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_URL
} = require('constants/index');

const HELP_LINK = '';

class BrokerTransferOfDerivativesWizardView extends React.Component {

    constructor(props) {
        super(props);

        this.onWillCancel = this.onWillCancel.bind(this)
    }

    componentWillUnmount() {
        this.props.reset();
    }

    onWillCancel() {
        this.props.history.push(MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_URL);
    }

    buildSideColumn() {
        const title = formatText('derivativeTransfer-title');
        const boxBody = (
            <div>
                <div className="broker-transfer-of-derivatives-wizard-view__content">
                    <FormattedText value="derivativeTransfer-content1" />
                </div>
                <div>
                    <FormattedText value="derivativeTransfer-content2" />
                </div>
            </div>
        );

        return <ContactInfoBox boxTitle={title} boxBody={boxBody} />;
    }

    buildWizard() {
        const {
            immAccounts,
            immBrokerCreateTransferOfDerivatives,
            immBrokerWallets,
            onValidateStep,
            onSetVisibleStep,
            onFinish,
            onChangeOriginDerivative,
            onChangeAmount,
            onChangeAccount
        } = this.props;

        const actions = {
            setVisibleStep: onSetVisibleStep,
            validateStep: onValidateStep,
            finish: onFinish,
            setWillCancel: this.onWillCancel
        };

        return (
            <BrokerCreateTransferOfDerivativesWizard
                immAccounts={immAccounts}
                immBrokerCreateTransferOfDerivatives={immBrokerCreateTransferOfDerivatives}
                immBrokerWallets={immBrokerWallets}
                actions={actions}
                onChangeOriginDerivative={onChangeOriginDerivative}
                onChangeAmount={onChangeAmount}
                onChangeAccount={onChangeAccount}
            />
        );
    }

    buildWizardSuccess() {
        const { immBrokerCreateTransferOfDerivatives, immBrokerWallets, immAccounts } = this.props;
        const accountsMap = immAccounts.get('byId');

        return (
            <BrokerCreateTransferOfDerivativesWizardSuccess
                immBrokerCreateTransferOfDerivatives={immBrokerCreateTransferOfDerivatives}
                immBrokerWallets={immBrokerWallets}
                immAccounts={accountsMap}
            />
        );
    }

    render() {
        const { immBrokerCreateTransferOfDerivatives, immVariables } = this.props;
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-derivativeTransfer'),
                url: ''
            }
        ];
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const commissionsButton = (
            <OKButton
                inverse={true}
                modifier="ghost"
                onClick={() => window.open(fees_url, '_blank')}
            >
                <FormattedText value="cashCharge-commissions" format="uppercase" />
            </OKButton>
        );
        const helpButton = (
            <OKButton
                inverse={true}
                modifier="ghost"
                onClick={() => window.open(HELP_LINK)}
            >
                <FormattedText value="cashCharge-help" format="uppercase" />
            </OKButton>
        );

        let content;

        if (immBrokerCreateTransferOfDerivatives.get('finished')) {
            content = this.buildWizardSuccess();
        } else {
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <section className="broker-transfer-of-derivatives-wizard-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('broker-transferOfDerivativesCreateHeaderTitle')}
                    >
                        {commissionsButton}
                        {helpButton}
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-transfer-of-derivatives-wizard-view__body">
                    {content}
                </section>
            </section>
        );
    }
}

BrokerTransferOfDerivativesWizardView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerCreateTransferOfDerivatives: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onChangeOriginDerivative: PropTypes.func.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onChangeAccount: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

module.exports.constructor = BrokerTransferOfDerivativesWizardView;
module.exports.BrokerTransferOfDerivativesWizardView = connect(
    state => ({
        immAccounts: state.accounts,
        immBrokerCreateTransferOfDerivatives: state.brokerCreateTransferOfDerivatives,
        immBrokerWallets: state.brokerWallets,
        immVariables: state.globalVariables
    }),
    {
        onValidateStep: BrokerCreateTransferOfDerivativesActions.validateStep,
        onSetVisibleStep: BrokerCreateTransferOfDerivativesActions.setVisibleStep,
        onFinish: BrokerCreateTransferOfDerivativesActions.finish,
        onChangeOriginDerivative: BrokerCreateTransferOfDerivativesActions.changeDerivativeOrigin,
        onChangeAmount: BrokerCreateTransferOfDerivativesActions.changeAmount,
        onChangeAccount: BrokerCreateTransferOfDerivativesActions.changeAccount,
        reset: BrokerCreateTransferOfDerivativesActions.reset
    }
)(withRouter(BrokerTransferOfDerivativesWizardView));
